import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-notification',
  template: `
    <p>
      notification works!
    </p>
  `,
  styles: [
  ]
})
export class NotificationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
